import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, Menu, X, FileText, BookOpen, Newspaper, Users, Info, Brain, Sun, Moon, Monitor, Bookmark, Trophy, Gamepad2, Shield } from 'lucide-react';
import { useTheme } from '../lib/theme';

const navIconMap = {
  Articles: <FileText size={16} />,
  Guides: <BookOpen size={16} />,
  Quizzes: <Brain size={16} />,
  Simulations: <Gamepad2 size={16} />,
  Games: <Shield size={16} />,
  News: <Newspaper size={16} />,
  Community: <Users size={16} />,
  About: <Info size={16} />,
};

const leftNav = [
  { path: '/articles', label: 'Articles' },
  { path: '/guides', label: 'Guides' },
  { path: '/games', label: 'Games' },
  { path: '/quizzes', label: 'Quizzes' },
  { path: '/simulations', label: 'Simulations' },
];

const rightNav = [
  { path: '/news', label: 'News' },
  { path: '/community', label: 'Community' },
  { path: '/about', label: 'About' },
];

const allNav = [...leftNav, ...rightNav];

export default function Header() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { themePreference, toggleTheme } = useTheme();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <div className="top-bar" />
      <header className="header">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <div className="container">
          <div className="header-inner">
            <div className="header-left">
              <Link to="/search" className="nav-search" aria-label="Search">
                <Search size={16} />
              </Link>
              <nav className="header-nav desktop-nav" aria-label="Primary">
                {leftNav.map(item => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                    aria-current={isActive(item.path) ? 'page' : undefined}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>

            <Link to="/" className="logo" onClick={() => setMobileOpen(false)}>
              <span className="logo-text">RBXSCAMS</span>
            </Link>

            <div className="header-right">
              <nav className="header-nav desktop-nav" aria-label="Secondary">
                {rightNav.map(item => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                    aria-current={isActive(item.path) ? 'page' : undefined}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
              <Link to="/read-later" className="header-icon-btn" aria-label="Read Later">
                <Bookmark size={16} />
              </Link>
              <Link to="/achievements" className="header-icon-btn" aria-label="Achievements">
                <Trophy size={16} />
              </Link>
              <button
                className="header-icon-btn theme-toggle"
                onClick={toggleTheme}
                aria-label={`Theme: ${themePreference}. Click to cycle.`}
              >
                {themePreference === 'dark' ? <Sun size={16} /> : themePreference === 'light' ? <Moon size={16} /> : <Monitor size={16} />}
              </button>
              <Link to="/contact" className="btn-cta">Contact Us</Link>
            </div>

              <button
                className={`hamburger ${mobileOpen ? 'open' : ''}`}
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="Toggle navigation"
                aria-expanded={mobileOpen}
              >
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        <div className={`mobile-menu ${mobileOpen ? 'open' : ''}`}>
          <div className="mobile-menu-inner">
            <nav className="mobile-nav" aria-label="Mobile navigation">
              {allNav.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={isActive(item.path) ? 'active' : ''}
                  aria-current={isActive(item.path) ? 'page' : undefined}
                  onClick={() => setMobileOpen(false)}
                >
                  <span className="mobile-nav-icon">{navIconMap[item.label]}</span>
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="mobile-divider" />
            <Link to="/read-later" className="mobile-search-link" onClick={() => setMobileOpen(false)}>
              <Bookmark size={16} />
              Read Later
            </Link>
            <Link to="/achievements" className="mobile-search-link" onClick={() => setMobileOpen(false)}>
              <Trophy size={16} />
              Achievements
            </Link>
            <Link to="/search" className="mobile-search-link" onClick={() => setMobileOpen(false)}>
              <Search size={16} />
              Search Articles, Guides & News
            </Link>
            <div className="mobile-divider" />
            <button className="mobile-search-link" onClick={toggleTheme}>
              {themePreference === 'dark' ? <Sun size={16} /> : themePreference === 'light' ? <Moon size={16} /> : <Monitor size={16} />}
              {themePreference === 'dark' ? 'Dark Mode' : themePreference === 'light' ? 'Light Mode' : 'System Mode'}
            </button>
            <Link to="/contact" className="btn-cta mobile-contact-btn" onClick={() => setMobileOpen(false)}>
              Contact Us
            </Link>
          </div>
        </div>
      </header>
    </>
  );
}
